
jQuery('.custom_button').click(function(){
    var video = jQuery(this).parents('.video_wrapper_custom').find('video');
if ($(this).hasClass("active")) {
    jQuery(this).removeClass('active');
video.trigger('pause');
} else {
video.trigger('play');
    jQuery(this).addClass('active');
}
});

jQuery('.question_product,.faq_question').click(function(){
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
});

jQuery('.trigger_show_more').click(function(){
jQuery(this).toggle();
    jQuery(this).parents('.richtext_blocks').find('.show_more_hidden').slideToggle();
});
jQuery('.color_swatch_custom').click(function(){
 var current_tab =jQuery(this).attr('data_tab');
jQuery(this).parents('.colors_variants_custom').find('.color_swatch_custom').removeClass('active');
jQuery(this).addClass('active');
jQuery(this).parents('.colors_variants_custom').next().find('.selected_color_details').hide();
jQuery(this).parents('.colors_variants_custom').next().find('.selected_color_details[data_tab="'+current_tab+'"]').show();
});

jQuery(".color_selector_input").change(function(){
    var current_tab = jQuery(this).val();
   // get data-image and data-name
   const dataImage = jQuery(this).attr('data-image');
    const dataName = jQuery(this).attr('data-name');
   const selected_image = document.querySelector('.selected_image');
   const selected_color_name = document.querySelector('.selected_color_name');
   selected_image.querySelector('img').src = dataImage;
   selected_color_name.innerText = dataName;
})